import { Exclude, Transform, Type } from 'class-transformer';

import { booleanTransform, centTransform, dateTransform, timeTransform } from '../utils/helper';
import { Campaign } from './campaign.model';
import { InsDate, InsModDate } from './date.model';
import { Headquarter } from './headquarter.model';

export class User extends InsModDate {
	id!: number;
	fname!: string;
	lname!: string;
	email!: string;
	mobile?: string;
	landline?: string;
	country?: string;
	iso?: string;
	comune?: string;
	province?: string;
	zipcode?: string;
	address?: string;
	streetno?: string;
	status!: string;
	@Transform(dateTransform)
	lastdate!: Date;
	token?: string;
	lang?: string;
	utype!: string;
	gender?: string;
	img?: string;
	banreason?: string;
	@Transform(dateTransform)
	birthdate?: Date;
	hqid?: number;

	@Transform(booleanTransform)
	creaactor?: boolean;

	// delivery
	vehiclebrand?: string;
	vehiclemodel?: string;
	vehicleyear?: string;
	vehicleplate?: string;
	@Transform(centTransform)
	centperkm?: number;
	paymode?: string;
	revenuesharepct?: number;
	@Transform(centTransform)
	revenueperenvelope?: number;
	@Transform(centTransform)
	daylyrevenue?: number;

	@Exclude({ toPlainOnly: true })
	@Type(() => Headquarter)
	headquarters?: Headquarter[];
	@Exclude({ toPlainOnly: true })
	@Type(() => Campaign)
	campaigns?: Campaign[];

	@Exclude({ toClassOnly: true })
	password?: string;

	// login-logout
	@Transform(dateTransform)
	logindate?: Date;
	@Transform(dateTransform)
	logoutdate?: Date;
	@Transform(dateTransform)
	lastactivitydate?: Date;
	@Transform(booleanTransform)
	logged?: boolean; // true->logged, false->not-logged

	@Transform(centTransform)
	daylytot!: number;

	get fullname(): string {
		return `${this.fname} ${this.lname}`;
	}

	get fulladdress(): string {
		let address = this.address ? this.address : '';
		if (this.streetno) {
			address += ` ${this.streetno}`;
		}
		if (this.comune) {
			address += ` ${this.comune}`;
		}
		if (this.zipcode) {
			address += ` ${this.zipcode}`;
		}
		return address;
	}

	get isActive(): boolean {
		return this.status === UserStatus.ACTIVE;
	}

	get isIdle(): boolean {
		return this.status === UserStatus.IDLE;
	}

	get isTypeFattorino(): boolean {
		return this.utype === UserType.FATTORINO;
	}

	get isTypeCallCenter(): boolean {
		return this.utype === UserType.CALL_CENTER;
	}

	get isTypeAdmin(): boolean {
		return this.utype === UserType.ADMIN;
	}

	get isPaymodePCT(): boolean {
		return this.paymode === UserPaymode.PCT;
	}

	get isPaymodePerday(): boolean {
		return this.paymode === UserPaymode.PERDAY;
	}

	get isPaymodePerevenelope(): boolean {
		return this.paymode === UserPaymode.PERENVELOPE;
	}

	get isNonAssegnato(): boolean {
		return !this.logged && !this.logindate && !this.logoutdate;
	}

	get opId(): string {
		return `OP${this.id}`;
	}

}

export class Usertorole extends InsDate {
	id!: number;
	rid!: number;
	uid!: number;
}

export class UserHeadquarter extends InsDate {
	id!: number;
	hid!: number;
	uid!: number;
}

export class UserConf extends InsModDate {
	id!: number;
	userid!: number;
	@Transform(centTransform)
	daylybudget?: number;
	daylyportfolioquota?: number;
	daylydormientiquota?: number;
	@Transform(centTransform)
	daylytot?: number;
	@Transform(booleanTransform)
	enabledaylyrecall?: boolean;
	@Transform(booleanTransform)
	privaterecall?: boolean;
	@Transform(booleanTransform)
	crosscampaingrecall?: number;
	@Transform(booleanTransform)
	showids?: number;
	recallperminalert?: number;
	recallperdayalert?: number;
	@Transform(centTransform)
	revenueoffer?: number;
}

export class UserCap extends InsModDate {
	id!: number;
	userid!: number;
	zipcode!: string;
}

export class UserTime extends InsModDate {
	id!: number;
	userid!: number;
	@Transform(timeTransform)
	ammonstart?: Date;
	@Transform(timeTransform)
	ammonend?: Date;
	@Transform(timeTransform)
	pmmonstart?: Date;
	@Transform(timeTransform)
	pmmonend?: Date;
	@Transform(timeTransform)
	amtuestart?: Date;
	@Transform(timeTransform)
	amtueend?: Date;
	@Transform(timeTransform)
	pmtuestart?: Date;
	@Transform(timeTransform)
	pmtueend?: Date;
	@Transform(timeTransform)
	amwedstart?: Date;
	@Transform(timeTransform)
	amwedend?: Date;
	@Transform(timeTransform)
	pmwedstart?: Date;
	@Transform(timeTransform)
	pmwedend?: Date;
	@Transform(timeTransform)
	amthustart?: Date;
	@Transform(timeTransform)
	amthuend?: Date;
	@Transform(timeTransform)
	pmthustart?: Date;
	@Transform(timeTransform)
	pmthuend?: Date;
	@Transform(timeTransform)
	amfristart?: Date;
	@Transform(timeTransform)
	amfriend?: Date;
	@Transform(timeTransform)
	pmfristart?: Date;
	@Transform(timeTransform)
	pmfriend?: Date;
	@Transform(timeTransform)
	amsatstart?: Date;
	@Transform(timeTransform)
	amsatend?: Date;
	@Transform(timeTransform)
	pmsatstart?: Date;
	@Transform(timeTransform)
	pmsatend?: Date;
}

export enum UserStatus {
	IDLE = 'idle',
	ACTIVE = 'active',
	INACTIVE = 'inactive'
}

export enum UserType {
	ADMIN = 'admin',
	FATTORINO = 'delivery',
	CALL_CENTER = 'callcenter'
}

export enum UserGender {
	MASCHIO = 'M',
	FEMMINA = 'F'
}

export enum UserPaymode {
	PERENVELOPE = 'perenvelope',
	PERDAY = 'perday',
	PCT = 'pct'
}
